import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Outlet,
} from "react-router-dom";
import Header from "./components/MainLayout/Header";
import Footer from "./components/MainLayout/Footer";
import Home from "./pages/Home/Home";
import About from "./pages/About/About";
import Login from "./pages/Login/Login";
import SSO from  "./components/SSO/SSO"
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute"; // Import ProtectedRoute

import ClientInfo from "./pages/Invoice/Create/Step1/ClientInfo";
import PointsInfo from "./pages/Invoice/Create/Step2/Points";
import Summary from "./pages/Invoice/Create/Step3/Summary";

import EditPoint from './pages/Invoice/Edit/EditPoint';

import "bootstrap/dist/css/bootstrap.min.css";
import "./styles.css";

// Layout with Header and Footer
const LayoutWithHeader = () => (
  <div className="d-flex flex-column min-vh-100">
    <Header />
    <main className="flex-grow-1">
      <div className="container">
        <Outlet />
      </div>
    </main>
    <div className="footer-margin">
      <Footer />
    </div>
  </div>
);

// Layout without Header and Footer
const LayoutWithoutHeader = () => (
  <div className="container">
    <Outlet />
  </div>
);

function App() {
  return (
    <Router>
      <Routes>
        {/* Public route - Login */}
        <Route path="/login" element={<Login />} />
        <Route path="/sso_connection" element={<SSO />} />
        <Route path="/sso_connection/:data" element={<SSO />} />

        {/* Protected routes with Header and Footer */}
        <Route element={<ProtectedRoute />}>
          <Route element={<LayoutWithHeader />}>
            <Route path="/" element={<Home />} />
            {/* Add more routes here that should have a header/footer */}
          </Route>
        </Route>

        {/* Protected routes without Header and Footer */}
        <Route element={<ProtectedRoute />}>
          <Route element={<LayoutWithoutHeader />}>
            <Route path="/about" element={<About />} />
            <Route path="/invoice/create" element={<ClientInfo />} />
            <Route path="/invoice/create/points" element={<PointsInfo />} />
            {/* Add more routes here that shouldn't have a header/footer */}
          </Route>
        </Route>

        {/* Protected standalone routes */}
        <Route element={<ProtectedRoute />}>
          <Route path="/invoice/create/step1" element={<ClientInfo />} />
          <Route path="/invoice/create/step1/:id" element={<ClientInfo />} />
          <Route path="/invoice/create/step2/:id" element={<PointsInfo />} />
          <Route path="/invoice/create/step3" element={<Summary />} />
          <Route path="/invoice/create/step3/:id" element={<Summary />} />
          <Route path="/invoice/edit-point" element={<EditPoint />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
